<template>
<div :class="cobrandClass">
  <slot :link="logoLink"></slot>
</div>
</template>

<script>
import { mapState } from 'pinia'
import { useCobrandStore } from '~/store/cobrand'
import env from "~/libs/env";

export default {
  data() {
    return {
      hpUrl: env('hpUrl'),
    }
  },
  async mounted() {
    const cobrandStore = useCobrandStore()
    cobrandStore.$patch({ affiliateCobrandEnabled: !!cobrandStore.affiliates })
  },
  async beforeUnmount() {
    // Disable affiliate cobrand if affiliates prop was passed
    if (this.affiliates) {
      useCobrandStore().$patch({ affiliateCobrandEnabled: false })
    }
  },
  props: ['affiliates'],
  computed: {
    ...mapState(useCobrandStore, {
      config: store => store.config,
      affiliatesEnabled: store => store.affiliateCobrandEnabled,
    }),
    cobrandClass () {
      if (!this.config) return null
      if (!this.config.name && this.config.logoUrl && this.affiliatesEnabled) return 'cobrand-prostar-share'
      return this.config.name ? `cobrand-${this.config.name}` : null
    },
    logoLink () {
      if (!this.config) return this.hpUrl
      if (this.config.link) return this.config.link
      return this.config.name ? this.hpUrl + this.config.name : this.hpUrl
    }
  }
}
</script>
